<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto py-[3.75vw] bg-[#F5F5F7]">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          课外课程体系-<span class="text-[#F28334] font-bold">寒暑假班</span>
        </div>
      </div>
    </div>

    <!-- 容器区域 -->
    <div
      class="relative w-[61.46vw] h-auto left-1/2 -translate-x-1/2 flex flex-col justify-center gap-[1.67vw]"
    >
      <!-- 文本容器 -->
      <div class="w-full flex flex-row gap-[1.67vw]">
        <div
          class="relative flex-1 h-auto flex flex-col justify-center gap-[0.94vw]"
        >
          <!-- 主标题框 -->
          <div class="h-auto flex justify-start items-center">
            <div
              class="text-[1.46vw] text-[#1A2233] font-harmony font-bold text-start"
            >
              课程综述
            </div>
          </div>
          <!-- 描述内容 -->
          <div class="h-auto flex justify-start items-center">
            <div
              class="text-[0.83vw] text-[#676B73] font-harmony font-normal text-start"
              style="text-align: justify; text-justify: inter-ideograph"
            >
              赛前集训班专为备战各类无人机比赛精心打造，课程以高强度、针对性的训练模式，助力学生在短时间内实现无人机飞行技能质的飞跃。全方位提升学生的飞行技能和比赛适应能力，让学生在模拟实战中积累经验，增强比赛信心。
            </div>
          </div>
        </div>
      </div>
      <!-- 展示内容 -->
      <div
        class="relative w-[61.46vw] h-[23.67vw] mx-auto mb-[3.22vw] flex flex-row justify-between items-start"
      >
        <!-- 展示内容左 -->
        <div
          class="relative flex flex-col w-[29.22vw] h-full bg-white rounded-xl"
        >
          <!-- 上方标题 -->
          <div
            class="relative h-[5.1vw] rounded-tl-xl rounded-tr-xl flex-col justify-start items-start gap-[0.64vw]"
          >
            <!-- 图片作为背景 -->
            <div
              class="absolute top-0 left-0 w-full h-full flex-1 p-[-1.25vw] overflow-hidden"
            >
              <el-image
                class="w-full h-full object-cover rounded-tl-xl rounded-tr-xl"
                :src="
                  require('@/assets/images/CourseSystem/module4/sample1.png')
                "
                lazy
              />
            </div>
            <!-- 标题 -->
            <div
              class="relative p-[1.25vw] justify-start text-white text-[1.25vw] font-normal font-harmony"
            >
              课程特色
            </div>
            <div
              class="relative w-[1.04vw] ml-[1.25vw] mt-[-0.5vw] outline outline-[0.1vw] outline-[#D9D9D9]"
            ></div>
          </div>
          <!-- 下方详情 -->
          <div
            class="relative flex-1 h-auto my-[0.83vw] pl-[1.25vw] pr-[2.19vw] flex flex-col justify-center gap-[1.66vw]"
          >
            <!-- 详情内容1 -->
            <div class="flex items-start gap-[0.52vw]">
              <!-- 图标 -->
              <i
                class="el-icon-info text-[0.5vw] text-[#F86C26] mt-[0.47vw]"
              ></i>
              <!-- 内容 -->
              <div
                class="h-auto flex flex-col justify-center items-start text-start font-harmony"
              >
                <div
                  class="text-[0.94vw] text-[#1A2233] font-harmony font-normal"
                >
                  精准聚焦比赛
                </div>
                <p
                  class="text-[0.83vw] text-[#9CA3AF] font-normal"
                  style="text-align: justify; text-justify: inter-ideograph"
                >
                  围绕各类无人机比赛规则、项目特点和评分标准设计课程，确保学生所学即所考，训练内容与比赛需求高度契合，极大提高训练的针对性和有效性。
                </p>
              </div>
            </div>
            <!-- 详情内容2 -->
            <div class="flex items-start gap-[0.52vw]">
              <!-- 图标 -->
              <i
                class="el-icon-info text-[0.5vw] text-[#F86C26] mt-[0.47vw]"
              ></i>
              <!-- 内容 -->
              <div
                class="h-auto flex flex-col justify-center items-start text-start font-harmony"
              >
                <div
                  class="text-[0.94vw] text-[#1A2233] font-harmony font-normal"
                >
                  实战模拟强化
                </div>
                <p
                  class="text-[0.83vw] text-[#9CA3AF] font-normal"
                  style="text-align: justify; text-justify: inter-ideograph"
                >
                  搭建高度还原真实比赛场景的模拟训练环境，涵盖比赛中的常见突发状况和复杂气象条件。
                </p>
              </div>
            </div>
            <!-- 详情内容3 -->
            <div class="flex items-start gap-[0.52vw]">
              <!-- 图标 -->
              <i
                class="el-icon-info text-[0.5vw] text-[#F86C26] mt-[0.47vw]"
              ></i>
              <!-- 内容 -->
              <div
                class="h-auto flex flex-col justify-center items-start text-start font-harmony"
              >
                <div
                  class="text-[0.94vw] text-[#1A2233] font-harmony font-normal"
                >
                  个性化指导提升
                </div>
                <p
                  class="text-[0.83vw] text-[#9CA3AF] font-normal"
                  style="text-align: justify; text-justify: inter-ideograph"
                >
                  关注每位学生的技能水平和学习进度，为学生制定个性化的训练计划。
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 展示内容右 -->
        <div
          class="relative flex flex-col w-[29.22vw] h-full bg-white rounded-xl"
        >
          <!-- 上方标题 -->
          <div
            class="relative h-[5.1vw] rounded-tl-xl rounded-tr-xl flex-col justify-start items-start gap-[0.64vw]"
          >
            <!-- 图片作为背景 -->
            <div
              class="absolute top-0 left-0 w-full h-full flex-1 p-[-1.25vw] overflow-hidden"
            >
              <el-image
                class="w-full h-full object-cover rounded-tl-xl rounded-tr-xl"
                :src="
                  require('@/assets/images/CourseSystem/module4/sample2.png')
                "
                lazy
              />
            </div>
            <!-- 标题 -->
            <div
              class="relative p-[1.25vw] justify-start text-white text-[1.25vw] font-normal font-harmony"
            >
              课程目标
            </div>
            <div
              class="relative w-[1.04vw] ml-[1.25vw] mt-[-0.5vw] outline outline-[0.1vw] outline-[#D9D9D9]"
            ></div>
          </div>
          <!-- 下方详情 -->
          <div
            class="relative flex-1 h-auto my-[0.83vw] pl-[1.25vw] pr-[2.19vw] py-[1.5vw] flex flex-col justify-between gap-[1.66vw]"
          >
            <!-- 详情内容1 -->
            <div class="flex items-start gap-[0.52vw]">
              <!-- 图标 -->
              <i
                class="el-icon-info text-[0.5vw] text-[#F86C26] mt-[0.47vw]"
              ></i>
              <!-- 内容 -->
              <div
                class="h-auto flex flex-col justify-center items-start text-start font-harmony"
              >
                <div
                  class="text-[0.94vw] text-[#1A2233] font-harmony font-normal"
                >
                  精通比赛规则与备赛策略
                </div>
                <p
                  class="text-[0.83vw] text-[#9CA3AF] font-normal"
                  style="text-align: justify; text-justify: inter-ideograph"
                ></p>
              </div>
            </div>
            <!-- 详情内容2 -->
            <div class="flex items-start gap-[0.52vw]">
              <!-- 图标 -->
              <i
                class="el-icon-info text-[0.5vw] text-[#F86C26] mt-[0.47vw]"
              ></i>
              <!-- 内容 -->
              <div
                class="h-auto flex flex-col justify-center items-start text-start font-harmony"
              >
                <div
                  class="text-[0.94vw] text-[#1A2233] font-harmony font-normal"
                >
                  培养良好的比赛心态和应变能力
                </div>
                <p
                  class="text-[0.83vw] text-[#9CA3AF] font-normal"
                  style="text-align: justify; text-justify: inter-ideograph"
                ></p>
              </div>
            </div>
            <!-- 详情内容3 -->
            <div class="flex items-start gap-[0.52vw]">
              <!-- 图标 -->
              <i
                class="el-icon-info text-[0.5vw] text-[#F86C26] mt-[0.47vw]"
              ></i>
              <!-- 内容 -->
              <div
                class="h-auto flex flex-col justify-center items-start text-start font-harmony"
              >
                <div
                  class="text-[0.94vw] text-[#1A2233] font-harmony font-normal"
                >
                  增强团队协作与沟通能力
                </div>
                <p
                  class="text-[0.83vw] text-[#9CA3AF] font-normal"
                  style="text-align: justify; text-justify: inter-ideograph"
                ></p>
              </div>
            </div>
            <!-- 详情内容4 -->
            <div class="flex items-start gap-[0.52vw]">
              <!-- 图标 -->
              <i
                class="el-icon-info text-[0.5vw] text-[#F86C26] mt-[0.47vw]"
              ></i>
              <!-- 内容 -->
              <div
                class="h-auto flex flex-col justify-center items-start text-start font-harmony"
              >
                <div
                  class="text-[0.94vw] text-[#1A2233] font-harmony font-normal"
                >
                  提升飞行技能与稳定性
                </div>
                <p
                  class="text-[0.83vw] text-[#9CA3AF] font-normal"
                  style="text-align: justify; text-justify: inter-ideograph"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 按钮容器 -->
    <el-button
      native-type="submit"
      class="flex mx-auto justify-center items-center custom-button"
      @mouseenter="hoverButton = true"
      @mouseleave="hoverButton = false"
      @click="smoothScrollToBottom"
    >
      免费试听
    </el-button>
  </div>
</template>

<script>
import {EventBus} from "@/utils/bus";

export default {
  name: "coursesystem-module5",
  data() {
    return {};
  },
  methods: {
    // 平滑滚动到底部
    smoothScrollToBottom() {
      // const targetScroll = document.documentElement.scrollHeight;
      // const startPosition = window.scrollY || window.pageYOffset;
      // const distance = targetScroll - startPosition;
      // let startTime = null;
      //
      // function animation(currentTime) {
      //   if (!startTime) startTime = currentTime;
      //   const timeElapsed = currentTime - startTime;
      //   const run = easeInOutQuad(timeElapsed, startPosition, distance, 1000);
      //   window.scrollTo(0, run);
      //   if (timeElapsed < 1000) requestAnimationFrame(animation);
      // }
      //
      // function easeInOutQuad(t, b, c, d) {
      //   t /= d / 2;
      //   if (t < 1) return (c / 2) * t * t + b;
      //   t--;
      //   return (-c / 2) * (t * (t - 2) - 1) + b;
      // }
      //
      // requestAnimationFrame(animation);
        EventBus.$emit('scroll-to-course','course7');

    },
  },
};
</script>

<style scoped>
/* 自定义按钮样式 */
.custom-button {
  width: 6.87vw;
  height: 2.92vw;
  background: #f28334 !important;
  border: none;
  border-radius: 0.25vw;
  transition: all 0.3s;
}

.custom-button :deep(span) {
  color: white;
  font-size: 1.04vw;
  font-weight: bold;
  font-family: "HarmonyOS Sans SC";
}

.custom-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0.2vw 0.6vw rgba(242, 131, 52, 0.5);
}
</style>
